import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {selectLocale} from 'src/modules/main/services/user-info-slice';

import {LocaleContext} from '@pb/kit-context-locale';

import type {Locale} from '@pb/kit-context-locale';

type Props = {
    children: React.ReactNode,
};

const DEFAULT_LOCALE: Locale = {
    currency: 'USD',
    dateFormat: 'MMDDYYYY',
    decimalFormat: 'PERIOD',
    thousandFormat: 'COMMA',
    paperFormat: 'LETTER',
    symbolPosition: 'RIGHT',
    nativeCurrency: true,
};

export const LocaleContextProvider = ({children}: Props) => {
    const userLocale = useSelector(selectLocale);

    const value = useMemo(() => ({
        locale: userLocale || DEFAULT_LOCALE,
    }), [userLocale]);

    return (
        <LocaleContext.Provider value={value}>
            {children}
        </LocaleContext.Provider>
    );
};
